import { Notify } from "../notify";

export default {
    data: {
        total: {
            sum: 0,
            count: 0,
        },
        items: {},
    },

    async init() {
        this.load();
    },

    set(data) {
        this.data = data;
    },

    async load() {
        let response = await fetch('/api/cart?lang=' + lang, { 
            headers: {'X-csrf-token': _token} 
        });

        let result = await response.json();
    
        if (result.error !== undefined) {
            Notify.error(result.error);
        } else {
            this.data = result;
        }
    },
}
